import { apiClient } from "../../lib/apiClient";
import type { Player, PlayersListResponse, UpdatePlayerInput } from "./types";

export interface ListPlayersParams {
  q?: string;
  page?: number;
  limit?: number;
}

/** Fetch a page of players for a project. */
export async function listPlayers(
  projectId: string,
  params: ListPlayersParams = {},
): Promise<PlayersListResponse> {
  const qs = new URLSearchParams();
  if (params.q) qs.set("q", params.q);
  if (params.page) qs.set("page", String(params.page));
  if (params.limit) qs.set("limit", String(params.limit));
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  const r = await apiClient.get<PlayersListResponse>(
    `/api/admin/projects/${encodeURIComponent(projectId)}/players${suffix}`,
  );
  return r.data;
}

/** Fetch one player's full record. */
export async function getPlayer(
  projectId: string,
  playerId: string,
): Promise<Player> {
  const r = await apiClient.get<Player>(
    `/api/admin/projects/${encodeURIComponent(projectId)}/players/${encodeURIComponent(playerId)}`,
  );
  return r.data;
}

/** PATCH a player. Last-write-wins — no If-Match etag. Returns the updated record. */
export async function updatePlayer(
  projectId: string,
  playerId: string,
  input: UpdatePlayerInput,
): Promise<Player> {
  const r = await apiClient.patch<Player>(
    `/api/admin/projects/${encodeURIComponent(projectId)}/players/${encodeURIComponent(playerId)}`,
    input,
  );
  return r.data;
}
